"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggedUserExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../services"));
const axios_1 = tslib_1.__importDefault(require("axios"));
const User_1 = tslib_1.__importDefault(require("../__model__/User"));
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
const getLoggedUser = toolkitRaw.createAsyncThunk('user/fetch_logged_user', async (data, { rejectWithValue, getState }) => {
    const state = getState();
    if (state.user.isAuthenticated && !data.forceUpdate) {
        return rejectWithValue({ message: 'Already Authenticated' });
    }
    try {
        const headers = {
            Authorization: `Bearer ${String(data.bearerToken)}`,
        };
        if (data === null || data === void 0 ? void 0 : data.idToken) {
            headers['Auth0-IdToken'] = data.idToken;
        }
        const requestMe = services_1.default.get('/api/me', {
            headers,
        });
        let requestUserinfo = new Promise((res) => res({}));
        if (!data.rejectRequestUserinfo) {
            requestUserinfo = axios_1.default.get(data.auth0IssuerBaseUrl + '/userinfo', {
                headers,
            });
        }
        const [meUser, auth0User] = await Promise.all([
            requestMe,
            requestUserinfo,
        ]);
        const avatar_with_fallback = (0, lodash_get_1.default)(meUser, 'data.data.links.avatar_url', 'https://dummyimage.com/600x400/000/fff');
        const avatar = (0, lodash_get_1.default)(meUser, 'data.data.links.avatar_url', '');
        const user = new User_1.default({
            id: meUser.data.data.id,
            attributes: meUser.data.data.attributes,
            links: meUser.data.data.links,
            meta: meUser.data.data.meta,
            avatar,
            language: meUser.data.data.attributes.locale,
            avatar_with_fallback,
        });
        user.auth0 = auth0User.data;
        return user.json;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getLoggedUserExtraReducers = (builder) => {
    builder.addCase(getLoggedUser.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(getLoggedUser.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.isAuthenticated = true;
        state.error = false;
    });
    builder.addCase(getLoggedUser.rejected, (state) => {
        state.loading = false;
        if (!state.isAuthenticated) {
            state.error = true;
        }
    });
};
exports.getLoggedUserExtraReducers = getLoggedUserExtraReducers;
exports.default = getLoggedUser;
//# sourceMappingURL=index.js.map